import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmBudgetEntity } from "./rm-budget.entity";
import { RmBudgetController } from "./rm-budget.controller";
import { RmBudgetService } from "./rm-budget.service";


@Module({
    imports: [
      TypeOrmModule.forFeature([RmBudgetEntity])
    ],
    controllers: [RmBudgetController],
    providers: [ApplicationExceptionHandler,RmBudgetController,RmBudgetService],
  })
  export class RmBudgetModule { }